import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link, { LinkProps } from '@material-ui/core/Link';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import HomeIcon from 'mdi-react/HomeIcon';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

/* eslint-disable no-nested-ternary */
export interface IBreadcrumb {
  title: string;
  href?: string;
}

interface IProps {
  breadcrumbs: IBreadcrumb[];
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    lists: {
      backgroundColor: theme.palette.background.paper,
      marginTop: theme.spacing(1),
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
  }),
);

interface ILinkRouterProps extends LinkProps {
  to: string;
  replace?: boolean;
}

const LinkRouter = (props: ILinkRouterProps) => <Link {...props} component={RouterLink as any} />;

export default function RouterBreadcrumbs(props: IProps) {
  const classes = useStyles({});
  const { breadcrumbs } = props;

  return (
    <div className={classes.root}>
      <Breadcrumbs aria-label="breadcrumb">
        <LinkRouter color="inherit" to="/">
          <HomeIcon size={12} />
        </LinkRouter>
        {breadcrumbs.map((value: IBreadcrumb, index: number) => {
          const last = index === breadcrumbs.length - 1;
          const { title, href } = value;

          return last || !href ? (
            <Typography color="primary" key={`bc-${title}-${href}`}>
              {title}
            </Typography>
          ) : (
            <LinkRouter color="inherit" to={href} key={`bc-${title}-${href}`}>
              {title}
            </LinkRouter>
          );
        })}
      </Breadcrumbs>
    </div>
  );
}